import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { FOCUS_RING } from '@common/components/interaction';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { useNonsanRouletteEntry } from '../_hooks/useNonsanRouletteEntry';
interface NonsanRouletteButtonProps {
  institutionName: string;
  paidAt: string;
  epayNumber: string;
  className?: string;
}
export const NonsanRouletteButton = t0 => {
  const $ = _c(15);
  let className;
  let params;
  if ($[0] !== t0) {
    ({
      className,
      ...params
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = params;
  } else {
    className = $[1];
    params = $[2];
  }
  const entry = useNonsanRouletteEntry(params);
  if (entry.kind === "hidden") {
    return null;
  }
  if (entry.kind === "loading") {
    let t1;
    if ($[3] !== className) {
      t1 = cn("h-40", className);
      $[3] = className;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    let t2;
    if ($[5] !== t1) {
      t2 = <div aria-hidden={true} className={t1} />;
      $[5] = t1;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  if (entry.kind === "disabled") {
    let t1;
    if ($[7] !== className || $[8] !== entry.label) {
      t1 = <Button dimensions="H40" className={className} disabled={true}>{entry.label}</Button>;
      $[7] = className;
      $[8] = entry.label;
      $[9] = t1;
    } else {
      t1 = $[9];
    }
    return t1;
  }
  const t1 = entry.href;
  let t2;
  if ($[10] !== className) {
    t2 = cn("flex h-40 items-center justify-center rounded-xsmall bg-[#c95759] font-700 text-Gray-white typo-body4", "transition-opacity duration-200 ease-out active:opacity-80 xl:hover:opacity-80", FOCUS_RING, className);
    $[10] = className;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== entry.href || $[13] !== t2) {
    t3 = <CustomLink href={t1} className={t2}>이벤트 참여하기</CustomLink>;
    $[12] = entry.href;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};